import { UtilityService } from '@eforall/common';
import { FilterOperator, GridColumn, buildColumn } from '@eforall/dashboard';
import { EngagementFollowUp } from '@interfaces';
import { AppService, DomainDataService } from '../../../../../services';

export function getColumns(util: UtilityService, app: AppService, domainDataService: DomainDataService) {
	const columns: GridColumn<EngagementFollowUp, unknown>[] = [
		buildColumn(util, 'Id', row => row.lastContactStaffId, { header: 'lastContactStaffId', hidden: true }),
		buildColumn(util, 'FullName', row => app.getStaffNameById(row.lastContactStaffId), { header: 'Last Contacted By', width: 80 }),
		buildColumn(util, 'Date', row => util.date.fromUTC(row.lastContactUTC), { header: 'Last Contact Date', width: 70 }),
		buildColumn(util, 'Id', row => row.followUpId, { header: 'followUpId', hidden: true }),
		buildColumn(util, 'FullName', row => row.person.fullName, { header: 'Name' }),
		buildColumn(util, 'Date', row => util.date.fromUTC(row.dueByUTC), { header: 'Follow-up Date' }),
		buildColumn(util, 'Id', row => row.staffId, { header: 'staffId', hidden: true }),
		buildColumn(util, 'FullName', row => app.getStaffNameById(row.staffId), { header: 'Staff' }),
		buildColumn(util, 'Text', row => domainDataService.data().engagementPurposesMap[row.purposeId]?.name, { header: 'Purpose' }),
		buildColumn(util, "Text", row => row.closedUTC ? "Yes" : "No", { header: 'Closed', filterType: 'text', filter: { operator: FilterOperator.EqualTo, value: "No" }, }),
		buildColumn(util, 'Date', row => util.date.fromUTC(row.closedUTC), { header: 'Closed Date', hidden: true }),
	];
	return columns;
}